import type { Step } from "@/config/steps"
import { sleep } from "@/lib/utils"

export type AssessmentLoadingStep =
  | Extract<Step, "SWIPE" | "DRIVE" | "BRAIN" | "VOICE" | "MOVE" | "MOVEBIS">
  | "SCAN"

const HOLD_KEY_PREFIX = "af:intro-debug-hold:"
const DEBUG_ASSESSMENTS: AssessmentLoadingStep[] = []

function getHoldKey(assessment: AssessmentLoadingStep) {
  return `${HOLD_KEY_PREFIX}${assessment}`
}

export function isAssessmentLoadingDebugEnabled(
  assessment: AssessmentLoadingStep
) {
  return import.meta.env.DEV && DEBUG_ASSESSMENTS.includes(assessment)
}

export function getAssessmentLoadingDebugHold(
  assessment: AssessmentLoadingStep
) {
  if (!isAssessmentLoadingDebugEnabled(assessment)) return false

  return localStorage.getItem(getHoldKey(assessment)) !== "off"
}

export function setAssessmentLoadingDebugHold(
  assessment: AssessmentLoadingStep,
  isHolding: boolean
) {
  if (!isAssessmentLoadingDebugEnabled(assessment)) return

  localStorage.setItem(getHoldKey(assessment), isHolding ? "on" : "off")
}

export async function waitForAssessmentLoadingDebugRelease(
  assessment: AssessmentLoadingStep
) {
  while (getAssessmentLoadingDebugHold(assessment)) {
    await sleep(250)
  }
}
